export const getSerializableSession = (session = {}) => {
  const {
    access,
    accessToken,
    config,
    hasExpired,
    identityToken,
    userInfo,
    validated,
  } = session || {}

  return {
    access,
    accessToken,
    config,
    hasExpired,
    identityToken,
    userInfo,
    validated,
  }
}
